import React from "react";
import Page from "@jumbo/shared/Page";
import ReceivedOA from "./ReceivedOA";
import OAWorkflowClient from "./OAWorkflowClient";

import TenantAdminRoute from "../../routes/TenantAdminRoute";

import { Navigate } from "react-router-dom";

const OA_routes = [
    {
        path: ["/oa", "/oa/received"],
        element: <TenantAdminRoute element={<Page component={ReceivedOA} />} />
    },
    {
        path: "/task-manager",
        element: <Navigate to="/task-manager/oa-workflow" replace />
    },
    {
        path: "/task-manager/oa-workflow",
        element: <TenantAdminRoute element={<Page component={() => <OAWorkflowClient workType="OA Shell" />} />} />
    },
    {
        path: "/task-manager/post-grant-workflow",
        element: <TenantAdminRoute element={<Page component={() => <OAWorkflowClient workType="Post Grant Support" />} />} />
    },
];

export default OA_routes;
